





















































































import Vue from 'vue'
import { groupBy } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { AvailableDate, Booking } from '@/store/interview/bookings/types'

import AvailableDateWidget from '@/components/interviews/AvailableDate.vue'
import BookingWidget from '@/components/interviews/Booking.vue'
import { availableDates } from '../../store/interview/bookings/getters'

const isFemale = (date: AvailableDate) => date.gender === 'FEMALE'
const isMale = (date: AvailableDate) => date.gender === 'MALE'
const returnTrue = () => true

export default Vue.extend({
  components: { AvailableDate: AvailableDateWidget, Booking: BookingWidget },
  computed: {
    ...mapGetters('interview/bookings', ['bookings', 'asInterviewer', 'asInterviewee']),

    allAvailableDates(): AvailableDate[] {
      return this.$store.getters['interview/bookings/availableDates'] as AvailableDate[]
    },

    availableDates(): AvailableDate[] {
      return this.allAvailableDates.filter(
        date =>
          (this.toggle == 'male' && isMale(date)) ||
          (this.toggle == 'female' && isFemale(date)) ||
          this.toggle == 'both'
      )
    },

    groupedDates(): Array<{ day: Date; dates: AvailableDate[] }> {
      const groups: { [date: string]: AvailableDate[] } = groupBy(
        this.availableDates,
        (slot: AvailableDate) => {
          const date = new Date(slot!.timeSlot!.start!.value)
          return date.toISOString().substring(0, 10)
        }
      )

      return Object.keys(groups)
        .sort()
        .map(day => ({ day: new Date(day), dates: groups[day] }))
    },

    countMale(): Number {
      return (
        this.allAvailableDates.filter(isMale).length - this.availableDates.filter(isMale).length
      )
    },

    countFemale(): Number {
      return (
        this.allAvailableDates.filter(isFemale).length - this.availableDates.filter(isFemale).length
      )
    },

    myActiveBookings(): Booking[] {
      return (this.$store.getters['interview/bookings/asInterviewee'] as Booking[]).filter(
        booking => !booking!.canceled && !booking!.offer!.post
      )
    },
  },
  data(): {
    selectedDate?: AvailableDate
    toggle: 'both' | 'female' | 'male'
  } {
    return {
      selectedDate: undefined,
      toggle: 'both',
    }
  },
  methods: {
    ...mapActions('interview/bookings', ['cancel']),
    book({ date }) {
      this.$store.dispatch({ type: 'interview/bookings/book', date }).then(result => {
        this.$emit('booked', result)
      })
    },
    isSelected(date: AvailableDate) {
      return this.selectedDate === date
    },
    select(date: AvailableDate) {
      if (this.isSelected(date)) {
        // toggle to unselected state
        this.selectedDate = undefined
      } else {
        this.selectedDate = date
      }
    },
  },
  watch: {
    toggle(newValue: 'both' | 'female' | 'male') {
      if (this.selectedDate) {
        if (
          (isMale(this.selectedDate) && newValue === 'female') ||
          (isFemale(this.selectedDate) && newValue === 'male')
        ) {
          this.selectedDate = undefined
        }
      }
    },
  },
})
